/* PostcodeLookup/Input.svelte generated by Svelte v3.24.0 */
import {
	SvelteComponent,
	append,
	attr,
	destroy_each,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	prevent_default,
	run_all,
	safe_not_equal,
	set_data,
	set_input_value,
	space,
	stop_propagation,
	text
} from "svelte/internal";

import { getContext } from "svelte";

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[9] = list[i];
	return child_ctx;
}

// (45:2) {#if completions && completions.length > 0}
function create_if_block(ctx) {
	let datalist;
	let each_value = /*completions*/ ctx[2];
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	return {
		c() {
			datalist = element("datalist");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			attr(datalist, "id", "autocomplete");
		},
		m(target, anchor) {
			insert(target, datalist, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(datalist, null);
			}
		},
		p(ctx, dirty) {
			if (dirty & /*completions*/ 4) {
				each_value = /*completions*/ ctx[2];
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(datalist, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}
		},
		d(detaching) {
			if (detaching) detach(datalist);
			destroy_each(each_blocks, detaching);
		}
	};
}

// (47:4) {#each completions as completion}
function create_each_block(ctx) {
	let option;
	let t_value = /*completion*/ ctx[9] + "";
	let t;
	let option_value_value;

	return {
		c() {
			option = element("option");
			t = text(t_value);
			option.__value = option_value_value = /*completion*/ ctx[9];
			option.value = option.__value;
		},
		m(target, anchor) {
			insert(target, option, anchor);
			append(option, t);
		},
		p(ctx, dirty) {
			if (dirty & /*completions*/ 4 && t_value !== (t_value = /*completion*/ ctx[9] + "")) set_data(t, t_value);

			if (dirty & /*completions*/ 4 && option_value_value !== (option_value_value = /*completion*/ ctx[9])) {
				option.__value = option_value_value;
				option.value = option.__value;
			}
		},
		d(detaching) {
			if (detaching) detach(option);
		}
	};
}

function create_fragment(ctx) {
	let div;
	let label;
	let t0;
	let label_class_value;
	let t1;
	let input;
	let input_class_value;
	let t2;
	let t3;
	let button;
	let t4;
	let button_class_value;
	let div_class_value;
	let mounted;
	let dispose;
	let if_block = /*completions*/ ctx[2] && /*completions*/ ctx[2].length > 0 && create_if_block(ctx);

	return {
		c() {
			div = element("div");
			label = element("label");
			t0 = text("Postcode Lookup");
			t1 = space();
			input = element("input");
			t2 = space();
			if (if_block) if_block.c();
			t3 = space();
			button = element("button");
			t4 = text("Lookup");
			attr(label, "class", label_class_value = /*classNames*/ ctx[1].label);
			attr(label, "for", "postcode-lookup-input");
			attr(input, "id", "postcode-lookup-input");
			attr(input, "list", "autocomplete");
			attr(input, "class", input_class_value = /*classNames*/ ctx[1].input);
			attr(input, "placeholder", "Enter your postcode");
			attr(input, "type", "text");
			attr(button, "class", button_class_value = /*classNames*/ ctx[1].button);
			attr(button, "type", "submit");
			attr(div, "data-testid", "container");
			attr(div, "class", div_class_value = /*classNames*/ ctx[1].container);
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, label);
			append(label, t0);
			append(div, t1);
			append(div, input);
			set_input_value(input, /*value*/ ctx[0]);
			append(div, t2);
			if (if_block) if_block.m(div, null);
			append(div, t3);
			append(div, button);
			append(button, t4);

			if (!mounted) {
				dispose = [
					listen(input, "input", /*input_input_handler*/ ctx[6]),
					listen(button, "click", stop_propagation(prevent_default(/*handleClick*/ ctx[3])))
				];

				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*classNames*/ 2 && label_class_value !== (label_class_value = /*classNames*/ ctx[1].label)) {
				attr(label, "class", label_class_value);
			}

			if (dirty & /*classNames*/ 2 && input_class_value !== (input_class_value = /*classNames*/ ctx[1].input)) {
				attr(input, "class", input_class_value);
			}

			if (dirty & /*value*/ 1 && input.value !== /*value*/ ctx[0]) {
				set_input_value(input, /*value*/ ctx[0]);
			}

			if (/*completions*/ ctx[2] && /*completions*/ ctx[2].length > 0) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					if_block.m(div, t3);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}

			if (dirty & /*classNames*/ 2 && button_class_value !== (button_class_value = /*classNames*/ ctx[1].button)) {
				attr(button, "class", button_class_value);
			}

			if (dirty & /*classNames*/ 2 && div_class_value !== (div_class_value = /*classNames*/ ctx[1].container)) {
				attr(div, "class", div_class_value);
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div);
			if (if_block) if_block.d();
			mounted = false;
			run_all(dispose);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { value = "" } = $$props;
	let { classNames = {} } = $$props;
	let { onLookup = () => null } = $$props;
	let { getClient = getContext("client") } = $$props;
	let response;
	let completions;

	const getAutocompletions = async () => {
		$$invalidate(2, completions = null);

		if (!value || value.length < 2) {
			return false;
		}

		response = await getClient().getAutocomplete(value);

		if (!response.isCompleted) {
			$$invalidate(2, completions = response.listCompletions());
			return;
		}

		const [[postcode]] = response;
		onLookup(postcode);
	};

	const handleClick = () => onLookup(value);

	function input_input_handler() {
		value = this.value;
		$$invalidate(0, value);
	}

	$$self.$set = $$props => {
		if ("value" in $$props) $$invalidate(0, value = $$props.value);
		if ("classNames" in $$props) $$invalidate(1, classNames = $$props.classNames);
		if ("onLookup" in $$props) $$invalidate(4, onLookup = $$props.onLookup);
		if ("getClient" in $$props) $$invalidate(5, getClient = $$props.getClient);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*value*/ 1) {
			$: (value, getAutocompletions());
		}
	};

	return [
		value,
		classNames,
		completions,
		handleClick,
		onLookup,
		getClient,
		input_input_handler
	];
}

class Input extends SvelteComponent {
	constructor(options) {
		super();

		init(this, options, instance, create_fragment, safe_not_equal, {
			value: 0,
			classNames: 1,
			onLookup: 4,
			getClient: 5
		});
	}
}

export default Input;